import * as ReCaptcha from '../../../components/form/recaptcha/main';

const reCapt = Array.from(document.getElementsByClassName('recaptcha-widget')) as ReCaptcha.Elm[];
reCapt.forEach(elm => ReCaptcha.init(elm));

const form     = document.getElementById('xsfp-order-form') as HTMLFormElement;
const button   = document.getElementById('contact-submit')     as HTMLButtonElement;

button.addEventListener('click', event => {
  event.preventDefault();

  reCapt.forEach(elm => elm.xIsValid());
  let isValid = reCapt.reduce( (allValid, elm) => allValid && elm.xIsValid(), true);

  if (isValid) {
    form.submit();
  }
})